export default __webpack_public_path__ + "static/media/basket.61b882d8.svg";